Namespace('Settings.Views.ChatbotConfiguration')

class Settings.Views.ChatbotConfiguration.MissingChatbotsView extends Backbone.View
  template: JST['backbone/templates/settings/chatbot_configuration/missing_chatbots']
  className: 'missing-chatbots-container mx-4 mt-4'

  initialize: () ->

  render: =>
    @$el.html(@template())
    @
